/**
 * Request Error types
 */
export enum RequestErrorType {
  CLIENTSIDE,
  SERVERSIDE,
}

/**
 * Request Error model
 */
export interface RequestError {
  /**
   * Type of error
   */
  type: RequestErrorType;
  /**
   * Body with error information
   */
  body: any;
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/models/Error.ts